import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  switchLabel: {
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
